<template>
  <div class="">
    <div>
      <div v-for="(group, index) in groups" :key="index+'users_group'" class="">
        <div class="">
          <div class="d-flex">
            <b-form-group
              class="ml-1 labelForSelect"
              style="min-width: 200px">
              <flat-pickr
                :id="id + 'startDate'"
                v-model="group.startDate"
                :config="datePickerConfig"
                :disabled="isSelectDisabled"
                class="timeNoBackground w-100"
                @input="onChange"
              />
              <div class="textHinnt">Fecha de inicio</div>
            </b-form-group>
            <b-form-group
              style="min-width: 200px"
              class="ml-1 labelForSelect">
              <flat-pickr
                :id="id + 'endDate'"
                v-model="group.endDate"
                :config="datePickerConfig"
                :disabled="isSelectDisabled"
                class="timeNoBackground w-100"
                @input="onChange"
              />
              <div class="textHinnt">Fecha de fin</div>
            </b-form-group>
            <b-form-group
              style="min-width: 200px"
              class="ml-1 labelForSelect">
              <v-select
                v-model="group.system"
                :options="systemOptions"
                :filterable="false"
                :multiple="false"
                :clearable="false"
                ref="selectable"
                class="w-100"
                :disabled="isSelectDisabled"
                append-to-body
              />
              <div class="textHinnt">Sistemas</div>
            </b-form-group>
            <b-form-group
              style="min-width: 200px;"
              class="ml-1">
              <b-form-textarea
                style="max-height: 50px;"
                id="docsComments"
                v-model="group.comments"
                @input="onChange"
                :disabled="isSelectDisabled"
                rows="3"
                max-rows="4"
              ></b-form-textarea>
              <div class="textHinnt">Comentarios</div>
            </b-form-group>
            <div style="min-width: 95px">
              <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group mb-1">Remove</a>
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="showBtnGroup && !isSelectDisabled"
        @click="addGroup"
        class="addGroupBtn"
        type="button" >
          <span>+ Documentación</span>
      </button>
    </div>

  </div>
</template>

<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {emit}) {
    const placeholderTranslation = 'custom_forms.select_user';
    const d = new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const defaultData = {
      system: null,
      startDate: `${day}/${month}/${year}`,
      endDate: `${day}/${month}/${year}`,
      comments: null,
    }
    const isSelectDisabled = ref(false);
    const groups = ref([{...defaultData}]);
    const showBtnGroup = ref(false);
    const systemOptions = ["CCTV", "Alarmas", "Control de accesos"];
    const datePickerConfig = {
      dateFormat: "d/m/Y",
      allowInput: true,
      locale: {
        firstDayOfWeek: 1,
      },
    };

    onMounted(async () => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
      showBtnGroup.value = props?.field?.options?.isGroup;
    });

    // Watchers
    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    function onChange() {
      emit("updateData", props.field, groups.value);
    }

    function addGroup() {
      groups.value.push({...defaultData})
    }

    function removeGroup(index) {
      if(groups.value.length === 1) return;
      groups.value.splice(index, 1);
      emit("updateData", props.field, groups.value);
    }

    return {
      placeholderTranslation,
      isSelectDisabled,
      groups,
      showBtnGroup,
      datePickerConfig,
      systemOptions,
      onChange,
      addGroup,
      removeGroup,
    }
  }
}
</script>
<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.input-group-repeatable-remove {
  background-color: #cecece;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 1.35em;
  height: 1.35em;
  transition: background-color 0.2s;
}
.input-group-repeatable-remove:hover {
  background-color: #dc2c2c;
}

.input-group-repeatable-remove::before,
.input-group-repeatable-remove::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 0.80em;
  height: 0.2em;
  background-color: white;
  transform-origin: center center;
  transition: transform 0.3s ease;
}

.input-group-repeatable-remove::before {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove::after {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove:hover::before {
  top: 42%;
  transform: translateX(-60%) rotate(45deg);
}

.input-group-repeatable-remove:hover::after {
  top: 42%;
  transform: translateX(-60%) rotate(-45deg);
}
.groupContainer {
  padding: 1em;
  border: 1px solid #efefef;
  border-radius: 0.3em;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
</style>
